/**
 * API Configuration
 * Centralized API endpoint configuration
 */

const API_BASE_URL =
  process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const BASE_URL = API_BASE_URL.replace('/api', '');

// Construct full URLs
const getApiUrl = (endpoint: string): string => {
  return `${API_BASE_URL}${
    endpoint.startsWith('/') ? endpoint : '/' + endpoint
  }`;
};

const getFileUrl = (filePath: string): string => {
  return `${BASE_URL}${filePath.startsWith('/') ? filePath : '/' + filePath}`;
};

export const apiConfig = {
  // Base URLs
  API_BASE_URL,
  BASE_URL,

  // Endpoints
  endpoints: {
    // Auth
    auth: {
      login: '/auth/login',
      register: '/auth/register',
      logout: '/auth/logout',
      forgotPassword: '/auth/forgot-password',
      resetPassword: '/auth/reset-password'
    },
    // Profile
    profile: {
      get: '/profile',
      update: '/profile'
    },
    // Shifts
    shifts: {
      getAll: '/shifts',
      create: '/shifts',
      update: (id: number) => `/shifts/${id}`,
      delete: (id: number) => `/shifts/${id}`
    },
    // Admin
    admin: {
      login: '/admin/login',
      dashboard: {
        overview: '/admin/dashboard/overview',
        bookingStatus: '/admin/dashboard/booking-status',
        recentBookings: '/admin/dashboard/recent-bookings'
      },
      users: {
        getAll: '/admin/users',
        get: (id: number) => `/admin/users/${id}`,
        update: (id: number) => `/admin/users/${id}`,
        delete: (id: number) => `/admin/users/${id}`
      },
      shifts: {
        getAll: '/admin/shifts',
        get: (id: number) => `/admin/shifts/${id}`,
        delete: (id: number) => `/admin/shifts/${id}`
      },
      bookings: {
        getAll: '/admin/bookings',
        get: (id: number) => `/admin/bookings/${id}`
      },
      analytics: '/admin/analytics'
    }
  },

  // Utility functions
  getApiUrl,
  getFileUrl,

  // File paths
  files: {
    documents: (filename: string) =>
      getFileUrl(`/uploads/documents/${filename}`)
  }
};

export default apiConfig;
